import { useEffect, useRef, useState } from "react";
import { Container, Typography } from "@mui/material";
import { motion, useScroll, useTransform, useInView } from "framer-motion";

function ScaleSection() {
  const [show, setShow] = useState(false);

  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { amount: 0.1 });
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  useEffect(() => {
    setShow(isInView);
  }, [isInView]);

  const opacity = useTransform(
    scrollYProgress,
    [0, 0.25, 0.5, 0.65, 0.8],
    [0, 0, 1, 1, 0]
  );

  const scale = useTransform(
    scrollYProgress,
    [0, 0.25, 0.35, 0.8],
    [0.8, 0.85, 0.9, 1]
  );

  return (
    <div ref={containerRef}>
      <Container
        sx={{
          maxWidth: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
            xxl: 1536,
          },
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {show && (
          <motion.div
            className="flex flex-col items-center justify-center fixed top-1/2 w-full md:w-[680px] lg:w-[730px] -z-10"
            style={{ opacity: opacity, scale: scale, y: "-50%" }}
          >
            <Typography
              variant="h2"
              component="h2"
              fontWeight={900}
              fontSize={{ xs: 40, md: 50, lg: 60 }}
              mb={2}
            >
              An intelligent home
            </Typography>
            <Typography
              variant="h4"
              component="h3"
              fontWeight={300}
              fontSize={{xs: 22, md: 26, lg: 30 }}
              textAlign="center"
            >
              always keeps you in the know.
              <br />
              Stay informed and in control of everything happening in and around
              your home—whether you're in the kitchen or across the world.
            </Typography>
          </motion.div>
        )}
      </Container>
    </div>
  );
}

export default ScaleSection;
